// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.range-input {
  padding-bottom: 5px;

  input {
    background-color: rgb(54, 54, 54);
    color: rgb(221, 221, 221);
    outline: none;
    border: none;
    margin-right: 4px;
    padding-top: 3px;
    padding-bottom: 3px;
    box-sizing: content-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/graphEditor/nodes/CustomAudio/ScaleAndShift/RangeInput.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB;IACE,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":[".range-input {\n  padding-bottom: 5px;\n\n  input {\n    background-color: rgb(54, 54, 54);\n    color: rgb(221, 221, 221);\n    outline: none;\n    border: none;\n    margin-right: 4px;\n    padding-top: 3px;\n    padding-bottom: 3px;\n    box-sizing: content-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
